import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Mail, LinkedinIcon, Award, GraduationCap } from "lucide-react";

const TeamMember1 = () => {
  return (
    <div className="py-8">
      {/* Header */}
      <section className="bg-gradient-to-br from-primary to-accent text-primary-foreground py-16">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="w-80 h-80 bg-primary-foreground/20 rounded-full mx-auto mb-6 flex items-center justify-center overflow-hidden">
              <img 
                src="/lovable-uploads/e830e263-c8ef-495a-bfa6-ad8a976a80f6.png" 
                alt="Mark Insley"
                className="w-full h-full object-cover"
              />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Mark Insley</h1>
            <p className="text-xl text-primary-foreground/90 mb-4">
              Director
            </p>
            <Badge className="bg-primary-foreground text-primary">Corporate Governance</Badge>
          </div>
        </div>
      </section>

      {/* Biography */}
      <section className="py-16 bg-background">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h2 className="text-3xl font-bold mb-6">Biography</h2>
              <div className="prose prose-lg text-muted-foreground space-y-4">
                <p>
                  Mark is the Founder & Managing Director of Ascot Wealth Management, which he established in 2010 
                  following a successful career in investment banking. He also serves as Director of Cape Berkshire 
                  Asset Management, bringing over 15 years of comprehensive experience in financial services and wealth management.
                </p>
                <p>
                  Under Mark's leadership, Ascot Wealth Management has grown into a respected advice practice 
                  specializing in Financial Advice, Wealth Management and Estate & Tax Planning. Mark is a strong 
                  believer in using technology in finance to enable clients to monitor their investments wherever they are.
                </p>
                <p>
                  Mark is among the small percentage of young IFAs in the UK's financial advisory industry. 
                  His extensive background in securities investments and banking, combined with his entrepreneurial 
                  approach, enables him to deliver innovative, client-focused investment solutions while maintaining 
                  the highest professional standards.
                </p>
              </div>
            </div>
            
            <div>
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <Award className="h-5 w-5" />
                    Qualifications & Expertise
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-3">
                    <li className="flex items-center">
                      <GraduationCap className="h-4 w-4 text-primary mr-2" />
                      <span className="text-sm">CertPFS</span>
                    </li>
                    <li className="flex items-center">
                      <GraduationCap className="h-4 w-4 text-primary mr-2" />
                      <span className="text-sm">MSc Int. Securities, Investments & Banking</span>
                    </li>
                  </ul>
                </CardContent>
              </Card>
              
              <Card className="mt-6">
                <CardHeader>
                  <CardTitle>Contact</CardTitle>
                </CardHeader>
                <CardContent>
                  <div className="space-y-3">
                    <Button variant="outline" className="w-full justify-start" asChild>
                      <a href="mailto:mark.insley@capeberkshire.co.uk">
                        <Mail className="h-4 w-4 mr-2" />
                        Send Message
                      </a>
                    </Button>
                    <Button variant="outline" className="w-full justify-start" asChild>
                      <a 
                        href="https://www.linkedin.com/in/markinsley/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <LinkedinIcon className="h-4 w-4 mr-2" />
                        LinkedIn Profile
                      </a>
                    </Button>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-primary text-primary-foreground">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Ready to Discuss Your Investment Strategy?
          </h2>
          <p className="text-xl mb-8 text-primary-foreground/90 max-w-2xl mx-auto">
            Get in touch with Mark and our team to learn more about our approach to wealth management.
          </p>
          <Button size="lg" variant="secondary" asChild>
            <Link to="/contact">Contact Our Team</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default TeamMember1;